'use strict';

import RapidMove from './rapidmove';

class Jog2 extends RapidMove {
    constructor(x: number | null = null, y: number | null = null) {
        super(x, y, null, null);
    }
}

export default Jog2;
